import React, { useState } from "react";
import { Menu, SubMenu, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "./index.scss";
import { Box, Button } from "@mui/material";
import ArrowDown from "@mui/icons-material/KeyboardArrowDown";
import ArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { SettingsIcon } from "assets/images/Icons";

export default function SectionedDropdown({ menuOptions, value, onSelect, action, color, platformMetrics }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const selectedItem = menuOptions.find((o) => o.id === value);
    const selectedGroup = value === "noMetric" ? null : selectedItem?.group?.name || "Others";

    const metricMap = Object.fromEntries(platformMetrics.map(metric => [metric.field, metric]));

    menuOptions.forEach(option => {
        const matchingMetric = metricMap[option.id];
        option.group = matchingMetric?.group || { name: "Others" };
    });

    const filteredMenuOptions = Array.isArray(menuOptions) ? menuOptions.filter(opt => opt.id !== "noMetric") : [];

    const sectionsMap = filteredMenuOptions.reduce((acc, option) => {
        const groupName = option.group?.name || "Others";
        if (!acc[groupName]) acc[groupName] = [];
        acc[groupName].push(option);
        return acc;
    }, {});

    const sections = Object.entries(sectionsMap)
        .map(([label, items]) => ({ label, items }))
        .sort((a, b) => {
            if (a.label === "Others") return 1;
            if (b.label === "Others") return -1;
            return a.label.localeCompare(b.label);
        });

    const selectedLabel =
        value === "noMetric"
            ? "No metric"
            : filteredMenuOptions.find((o) => o.id === value)?.label || "Select...";

    return (
        <div>
            <Menu className="sectionned-dropdown"
                menuButton={
                    <Button
                        variant="outlined"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        sx={{
                            minHeight: "26px",
                            minWidth: "0px",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            display: "flex",
                            justifyContent: "space-between",
                            border: "none",
                            paddingLeft: "0",
                            paddingRight: "0",
                            textTransform: "none",
                            "&:hover": { border: "none" },
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                transform: "translateX(4px)",
                            }}
                        >
                        <span
                            style={{
                                fontSize: "12px",
                                paddingBottom: "2px",
                                fontWeight: 600,
                                color: "black",
                                fontFamily: "Inter",
                            }}
                        >
                          {selectedLabel}
                        </span>
                            {isMenuOpen ? (
                                <ArrowUp sx={{ fontSize: "24px", color: "black",  transform: "translateX(4px)" }} />
                            ) : (
                                <ArrowDown sx={{ fontSize: "24px", color: "black",  transform: "translateX(4px)"}} />
                            )}
                        </Box>
                    </Button>

                }
                onMenuChange={(e) => setIsMenuOpen(e.open)}
            >
                <div
                    className="menu-header"
                    onClick={() => onSelect("noMetric")}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <span className="change-metric">No Metric</span>
                    <SettingsIcon color={"#BAB7B7"} />
                </div>

                {sections.map((section, index) => (
                    <SubMenu
                        key={index}
                        label={
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: "12px",
                                        color: "black",
                                        fontFamily: "Inter",
                                        fontWeight: "400",
                                    }}
                                >
                                    {section.label}
                                </span>
                                {section.label === selectedGroup && color && (
                                    <Box
                                        sx={{
                                            width: "8px",
                                            height: "8px",
                                            borderRadius: "50%",
                                            backgroundColor: color,
                                            flexShrink: 0,
                                        }}
                                    />
                                )}
                            </Box>
                        }
                        arrow={false}
                    >
                        {section.items.map((item) => (
                            <MenuItem key={item.id} onClick={() => onSelect(item.id)}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: "12px",
                                            color: "black",
                                            fontFamily: "Inter",
                                            fontWeight: "400",
                                        }}
                                    >
                                        {item.label}
                                    </span>
                                    {item.id === value && color && (
                                        <Box
                                            sx={{
                                                width: "6px",
                                                height: "6px",
                                                borderRadius: "50%",
                                                backgroundColor: color,
                                                flexShrink: 0,
                                            }}
                                        />
                                    )}
                                </Box>
                            </MenuItem>
                        ))}
                        <hr className="menu-separator" />
                    </SubMenu>
                ))}

                <hr className="menu-separator" />

                {action && (
                    <MenuItem
                        onClick={(e) => {
                            e.keepOpen = true;
                        }}
                        style={{
                            padding: "10px 12px",
                            cursor: "default",
                            pointerEvents: "auto",
                        }}
                    >
                        {action}
                    </MenuItem>
                )}
            </Menu>
        </div>
    );
}
